import { render, staticRenderFns } from "./AdminMailPersistenceEvents.vue?vue&type=template&id=70f08e00&scoped=true&"
import script from "./AdminMailPersistenceEvents.vue?vue&type=script&lang=js&"
export * from "./AdminMailPersistenceEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f08e00",
  null
  
)

export default component.exports